
import axios from "axios";
import { toast } from "react-toastify";
import { environmentVariables } from "../../../config/env.config";

export const downloadAppleWalletPass = async (id) => {
  const baseUrl = environmentVariables?.apiUrl;
  try {
    const response = await axios.post(
      `${baseUrl}api/v1/applewallet/create-pass?id=${id}`
    );
    const fileUrl = response?.data?.fileUrl;
    if (!fileUrl) {
      toast.error("File URL not found in response.");
      return;
    }

    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = "business-pass.pkpass";
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error("Error downloading Apple Wallet pass:", error);
     toast.error(error?.response?.data?.message || error?.message || "An error occurred while downloading the pass.");
  }
};
